import { useQuery } from 'react-query';
import { UserType } from '../types/types';

const baseRoute = process.env.REACT_APP_BASE_URL;

export type PagosResponseType = { year: string, month: string };
export type ReportePagosType = { fecha: string, importe: number, recibidoPor:string, obs: string, transferencia: boolean };
export interface ReporteDeudaType {
  monto: number;
  montoOriginal: number;
  montoTransferencia: number;
  year: number;
  month: number;
  pagos: ReportePagosType[];
  descuento: number,
  error?: string,
  saldado?: boolean;
  alumnoId: string,
  nombre: string,
  inactivo?: boolean,
  esMatricula?: boolean;
  esSeguro?: boolean;
  _id: string,
}

async function reporteDeudaApiCall(id?:string[] | null, user?: UserType | null, verHistorico?: boolean) {
  if (!user?.token) return null;
  if (id === null) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };

  let params = '';

  if (verHistorico) {
    if (params.length > 0) {
      params += '&verHistorico=true';
    } else {
      params += '?verHistorico=true';
    }
  }

  const response = await fetch(
    `${baseRoute}/api/pagos/reporteDeuda${params}`,
    { headers, body: JSON.stringify(id), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as ReporteDeudaType[];
}


export function useGetReporteDeuda(id?:string[] | null, user?: UserType | null, verHistoricos?: boolean) {
  return useQuery<ReporteDeudaType[] | null, Error>(
    ['getReporteDeuda', id, user?._id],
    () => reporteDeudaApiCall(id, user, verHistoricos), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}
